module.exports = __webpack_public_path__ + "static/media/groupama.c9e16fe9.svg";